module.exports = __webpack_public_path__ + "static/img/maritza.24072b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maritza.jpg
// module id = 6UCW
// module chunks = 1